import { Button, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useDelete from '../../../hooks/product/useDelete';
import toast from 'react-hot-toast';
import Loader from '../../../components/loader';
// import Spinner from '../../components/spinner'; 

function DeleteTestimonial({ open, onClose, testimonial_id, onDelete }) {
    const { handleDelete, isLoading } = useDelete({
        url: 'delete-testimonial',
        refreshUrl: 'get-testimonial-list',
        successToastMessage: "Testimonial Deleted Successfully",
        successToastMessage: "Testimonial Deleted Successfully",
        onSuccess: () => {
            onDelete();
        },
        onError: (err) => {
            toast.error(err?.response?.data?.message || err?.message || "Failed to delete testimonial");
            console.error(err);
        }
    });

    const handleDeleteAction = (e) => {
        e.preventDefault();
        handleDelete({ testimonial_id });
    };

    return (
        <>
            <Dialog fullWidth={true} maxWidth={'sm'} open={open} onClose={onClose}>
                <div className='bg-white w-full px-5'>
                    <div className='modal-head flex items-center justify-end pt-2'>
                        <div onClick={onClose}>
                            <IconButton>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </div>
                    <form className='space-y-4' onSubmit={handleDeleteAction}>
                        <div className='space-y-7'>
                            <div>
                                <h1 className='text-2xl text-red-700 font-semibold text-center'>
                                    Are You Sure You Want To Delete?
                                </h1>
                            </div>
                        </div>
                        <div className='space-x-4 text-center pb-5'>
                            <Button
                                type='submit'
                                variant="contained"
                                color="error"
                                disabled={isLoading}
                            >
                                <div className="flex items-center gap-2">
                                    {isLoading && <Loader className="h-4 w-4" />}
                                    Delete
                                </div>
                            </Button>

                            <Button
                                variant="outlined"
                                color='info'
                                onClick={onClose}
                                disabled={isLoading}
                            >
                                Close
                            </Button>
                        </div>
                    </form>
                </div>
            </Dialog>
        </>
    );
}

export default DeleteTestimonial;
